import { formatLocalIsoDate } from "@/shared/utils/time"

// History groups sleeps by the calendar day they started (the day arc uses the same model).
// The noon→noon "sleep-day" is a stats-only concept — it keeps a night whole within one bar.

export function dayKey(date: Date): string {
  return formatLocalIsoDate(date)
}

export function previousDayKey(key: string): string {
  const [y, m, d] = key.split("-").map(Number)
  return formatLocalIsoDate(new Date(y, m - 1, d - 1))
}

const headerFormat = new Intl.DateTimeFormat("sv-SE", {
  weekday: "long",
  day: "numeric",
  month: "long",
})

export function dayHeader(key: string, todayKey: string): string {
  if (key === todayKey) return "Idag"
  if (key === previousDayKey(todayKey)) return "Igår"
  const [y, m, d] = key.split("-").map(Number)
  return headerFormat.format(new Date(y, m - 1, d))
}

export interface DayGroup<T> {
  key: string
  sessions: T[]
}

export function groupByDay<T extends { startTime: string }>(sessions: readonly T[]): DayGroup<T>[] {
  const byKey = new Map<string, T[]>()
  for (const session of sessions) {
    const key = dayKey(new Date(session.startTime))
    const bucket = byKey.get(key)
    if (bucket) {
      bucket.push(session)
    } else {
      byKey.set(key, [session])
    }
  }

  return [...byKey.keys()]
    .sort((a, b) => b.localeCompare(a))
    .map((key) => ({
      key,
      sessions: (byKey.get(key) ?? []).sort((a, b) => b.startTime.localeCompare(a.startTime)),
    }))
}
